import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import Table from "nood-comp/src/comp/data/table/Table";
import Flex from "nood-comp/src/comp/ui/containers/Flex";
import Text from "nood-comp/src/comp/text/Text";
import FlexVertical from "nood-comp/src/comp/ui/containers/flex-boxes/FlexVertical";
import DateTimeViewer from "nood-comp/src/comp/ui/date-viewer/DateTimeViewer";
import { date_util } from "nood-comp/src/util/date/DateUtil";
import { useModalContext } from "nood-comp/src/comp/modal/NoodleModalProvider";
import { _put } from "nood-comp/src/net/xhr";
import { RandomStringGenerator } from "nood-comp/src/util/rand/RandomStringGenerator";
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
export default function TierBatching(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isBatching = _useState2[0],
    setIsBatching = _useState2[1];
  var _useState3 = useState(function () {
      return RandomStringGenerator.alphanum(10);
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    random = _useState4[0],
    setRandom = _useState4[1];
  var modalCtx = useModalContext();
  var __resetTiers = function __resetTiers() {
    if (!isBatching) {
      modalCtx.__confirm("Are you sure you want to reset tiers for all expired organizations? This action cannot be undone.", {
        title: "Batch Reset Tier",
        primary: {
          icon: "refresh-cw",
          label: "Reset Tiers",
          nature: "negative",
          __do: function __do(idx, operations) {
            setIsBatching(true);
            operations.setIsProcessing(true);
            _put("/orgs?do=batch-tier-reset", {}, function (res) {
              operations.setIsProcessing(false);
              setIsBatching(false);
              operations.onAfterDo(res, function () {
                modalCtx.__closeModal(idx);
                setRandom(RandomStringGenerator.alphanum(10));
              });
            });
          }
        },
        secondary: {
          label: "Cancel",
          icon: "x"
        }
      });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Batch Reset Tier",
    rightControl: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", _extends({
      onClick: function onClick() {
        __resetTiers();
      }
    }, {
      className: "TierBatching__ui.button ev1h2kqdt ev19fdcxl ev5zlb00 evf48clv ev1v9t41d evxwrc4x ev1b0nn0a ev1wty727 ev1ypdohk"
    }), /*#__PURE__*/React.createElement(Flex, {
      gap: 8
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
      icon: "refresh-cw"
    })), /*#__PURE__*/React.createElement("div", null, "Batch Reset Tier"))))
  }), /*#__PURE__*/React.createElement(Table, {
    data_source: "/orgs?for=batch&random=".concat(random),
    cols: [{
      property: "username",
      label: "Org",
      filterType: "text",
      filterPlaceholder: "Short Name",
      icon: "tag",
      content: function content(obj, idx) {
        return /*#__PURE__*/React.createElement(Flex, {
          gap: 8
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement(Text, null, obj.display_name), /*#__PURE__*/React.createElement(Text, null, obj.username))));
      }
    }, {
      property: "tier_expiry",
      label: "Expiry",
      filterType: "date",
      filterPlaceholder: "Expiry Date",
      icon: "calendar",
      content: function content(obj, idx) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DateTimeViewer, {
          date: obj.tier_expiry,
          view_format: date_util.formats.output.short_with_time,
          show_duration: true,
          duration_css: {
            fontSize: 12,
            color: "var(--shade-50)"
          }
        }));
      }
    }, {
      property: "tier",
      label: "Tier",
      filterType: "dropdown",
      dropdownFilterOptions: [{
        value: 2,
        code: "Basic"
      }, {
        value: 3,
        code: "Pro"
      }],
      filterPlaceholder: "Tier Name",
      icon: "award",
      width: 150,
      content: function content(obj, idx) {
        var _obj$tier_;
        return /*#__PURE__*/React.createElement(React.Fragment, null, (_obj$tier_ = obj.tier_) === null || _obj$tier_ === void 0 ? void 0 : _obj$tier_.name);
      }
    }]
  }));
}

// @ts-ignore
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".ev19fdcxl{background-color:var(--shade-negative-darker)}", 3000);
_inject(".ev5zlb00:hover{background-color:var(--shade-negative-dark)}", 3130);
_inject(".evf48clv:active{background-color:var(--shade-negative)}", 3170);
_inject(".ev1v9t41d{padding:4px 10px}", 1000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev1b0nn0a{color:var(--text-on-shade-negative)}", 3000);
_inject(".ev1wty727{border:0}", 1000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);